/**
 * Shared color constants for axis, phase, and source badge colors.
 * Used across Map, List, Matrix, and Dashboard views.
 *
 * Initiative and status colors live in map-colors.ts.
 */

import type { AdjacencyAxis, DataSource } from '../types/adjacency';

export const AXIS_COLORS: Record<AdjacencyAxis, string> = {
  'Core': '#f1f5f9',
  'New Services': '#38bdf8',
  'New Markets & Customers': '#f59e0b',
  'Forward Integration': '#22c55e',
  'New Technologies & Capabilities': '#a78bfa',
  'New Channels': '#f472b6',
  'New Geographies': '#fb923c',
  'Backward Integration': '#2dd4bf',
  'New Products': '#818cf8',
};

export const PHASE_COLORS: Record<string, string> = {
  'Discovery': '#6366f1',
  'Definition': '#818cf8',
  'Feasibility': '#a78bfa',
  'Development': '#c084fc',
  'Beta': '#d946ef',
  'Launch': '#22c55e',
  'Production': '#10b981',
};

export const SOURCE_COLORS: Record<DataSource, string> = {
  'priority-list': '#3b82f6',
  'adjacency-map': '#94a3b8',
  'manual': '#f59e0b',
};

export const SOURCE_LABELS: Record<DataSource, string> = {
  'priority-list': 'Priority List',
  'adjacency-map': 'Adjacency Map',
  'manual': 'Manual',
};
